import React, { useContext } from 'react'
import { useQuery } from 'react-query'
import { DashboardContext } from '../Context/DashboardContext'
import AuthAxios from '../utils/AuthAxios'

const deleteuserstory = async (id) => {
    const response = await AuthAxios?.get(`/story/delete/${id}`)
    const data = response.data.data
    return data
  }



export default function useStorydelete(id) {

    const {deletestory, setDeleteStory,} = useContext(DashboardContext);
      return useQuery('delete story', ()=> deleteuserstory(id), {
        refetchOnWindowFocus: false ,
        enabled: false,
        
        onSuccess: (data, message) => {
            //  console.log(data, "deleted response")
             setDeleteStory(data);
          },


          onError: (error)=>{
            // console.log(error, "error occured")
          }

      })
}
